"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSkeleton = exports.ProductBoxRoot = exports.Ppa = exports.NamesWrapper = exports.Name = exports.ImageWrapper = exports.Brand = exports.BasicSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
var _presentationUtils = require("@ori/presentation-utils");
var _common = require("../common");
const ProductBoxRoot = exports.ProductBoxRoot = (0, _mui.styled)('a', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isLink = true
}) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: _common.FONT_SANS_ORI,
  cursor: isLink ? 'pointer' : 'default',
  gap: theme.spacing(2),
  textDecoration: 'none',
  overflow: 'hidden',
  '& *': {
    boxSizing: 'border-box'
  },
  '&:hover': {
    color: isLink ? theme.palette.text.secondary : 'initial'
  },
  '&:hover .imageZoom': {
    transform: isLink ? 'translate(-50%, -50%) scale(1.1)' : 'translate(-50%, -50%)'
  },
  '&:focus': {
    color: isLink ? theme.palette.text.secondary : 'initial'
  },
  '&:active': {
    color: isLink ? theme.palette.text.secondary : 'initial'
  }
}));
const Ppa = exports.Ppa = (0, _mui.styled)(_presentationComponents.PpaLabel)({
  borderBottomLeftRadius: '5px',
  borderBottomRightRadius: '5px'
});
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  height: 0,
  paddingTop: '100%',
  overflow: 'hidden',
  borderTopLeftRadius: 5,
  borderTopRightRadius: 5,
  background: theme.palette.grey[100]
}));
const NamesWrapper = exports.NamesWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(1)
}));
const Brand = exports.Brand = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  fontSize: '1rem',
  letterSpacing: 2,
  lineHeight: '1.5rem',
  overflow: 'hidden',
  textAlign: 'left',
  textTransform: 'uppercase',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  width: '100%'
}));
const Name = exports.Name = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  lineHeight: '2rem',
  overflow: 'hidden',
  textAlign: 'left',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  width: '100%'
}));

// Disable 'transform' which may ori-ui/mui skeleton have
const BasicSkeleton = exports.BasicSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  transform: 'none'
});
const TextSkeleton = exports.TextSkeleton = (0, _mui.styled)(BasicSkeleton, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['marginTop'])
})(({
  marginTop
}) => ({
  marginTop
}));
//# sourceMappingURL=styles.js.map